<template>
<div class="chapter">
<div class="inner_page">
<div id="fm6">
<p class="dedication"><span>TO</span></p>
<p class="dedication1"><span>PAUL H. PHELPS, JR.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?3057aced